<template>
	<div class="calendar">
		<div>
			<div class="left">
				<div class="year">
					<p><span @click="nextYear()"><i class="el-icon-arrow-up"></i></span></p>
					<p><span class="currentYear">{{currentYear}}年</span></p>
					<p><span @click="prveYear()"><i class="el-icon-arrow-down"></i></span></p>
				</div>
				<ul class="month">
					<li v-for="(month,i) in monthList" :key="i">
						<span @click="changeMonth(i+1)" :class="{'active':i+1==currentMon}">{{month}}</span>
					</li>
				</ul>
			</div>
		</div>
		<div>
			<div class="center">
				<h2>{{currentYear}}年·{{monthList[currentMon-1]}}</h2>
				<div class="day">
					<ul class="week">
						<li v-for="(week,i) in weekDays" :key="i"><span>{{week}}</span></li>
					</ul>
					<ul style="margin-top: 5px;">
						<!-- 	<li v-for="(week,i) in weekDay" :key="i"><span></span></li> -->
						<li v-for="day in days" :key="index">
							<span v-if="day.type!='this'"></span>
							<span class="Agency" @click="readMessage(day)" v-if="day.type=='this'" :class="{'active':day.undone,'finish active':day.undone==0&&day.completed>0}"><span>{{day.day}}</span>
								<font v-if="day.undone>0">{{day.undone}}条待办</font>
								<font v-if="day.undone==0&&day.completed>0">完成</font>
								<!-- <font v-if="day.todoNum">{{day.todoNum}}条待办</font> -->
							</span>
							<span class="festival" v-if="day.type=='this'&&day.workType">{{day.workType=='10800002'?'上班':'休息'}}</span>
						</li>
					</ul>
				</div>
				<div class="footer">
					<div>
						<!-- <img src="@/assets/img/main/icon-tianjia.svg" alt=""> -->
						<el-popover placement="right-end" width="280" trigger="click" v-model="visible">
							<el-form ref="form" id="form" :model="form" :rules="rules" label-width="0" show-message="false">
								<el-form-item prop="toDoDate">
									<el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form.toDoDate" style="width: 100%;"></el-date-picker>
								</el-form-item>
								<el-form-item>
									<el-col :span="8">
										<el-form-item prop="toDoStartTime">
											<el-time-select placeholder="开始时间" v-model="form.toDoStartTime" :picker-options="{
											start: '00:00',
											step: '00:15',
											end: '23:59'
										}">
											</el-time-select>
										</el-form-item>
									</el-col>
									<el-col :span="2">
										&nbsp;至
									</el-col>
									<el-col :span="8">
										<el-form-item prop="toDoEndTime">
											<el-time-select placeholder="结束时间" v-model="form.toDoEndTime" :picker-options="{
											start: '00:00',
											step: '00:15',
											end: '23:59',
											minTime: form.toDoStartTime
										}">
											</el-time-select>
										</el-form-item>
									</el-col>
									<el-col :span="1">
										&nbsp;
									</el-col>
									<el-col :span="5">
										<el-checkbox v-model="radio">全天</el-checkbox>
									</el-col>
								</el-form-item>
								<el-form-item prop="toDoName">
									<el-input type="textarea" class="textarea" placeholder="请填写详细提示信息" maxlength="80" show-word-limit v-model="form.toDoName">
									</el-input>
								</el-form-item>
								<el-form-item class="remind" prop="toDoRemindLong" label-width="70px" label="提醒设置">
									<el-select v-model="form.toDoRemindLong" placeholder="请选择">
										<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item prop="toDoRemindType" label-width="80px" v-if="showRemindType" label="提醒方式">
									<el-col :span="6">
										<el-checkbox-group v-model="form.toDoRemindType">
											<el-checkbox v-for="way in ways" :label="way.value" :key="way.value">{{way.label}}</el-checkbox>
										</el-checkbox-group>
									</el-col>
								</el-form-item>
								<el-form-item id="save">
									<el-button type="primary" @click="onSubmit">保存</el-button>
								</el-form-item>
							</el-form>
							<img slot="reference" src="@/assets/img/main/icon-tianjia2.svg" :class="{'showMask':visible}" style="width: 40px;outline: none;"
							 alt="">
						</el-popover>
					</div>
				</div>
			</div>

		</div>
		<div class="right">
			<div style="height:100%">
				<h3>
					<div>
						<font>{{currentDay}}</font>日/{{currentMon}}月
					</div>
					<div>{{lunar}}</div>
					<div>星期{{weekDays[getWeek]}}</div>
					<div>{{weekDaysE[getWeek]}}</div>
				</h3>
				<div class="datalists" v-loading="loading">
					<div  style="height:100%" v-for="message in Messages" :key="message.msgType">
						<h2Title :title="message.msgTypeName" style="margin-top: 10px;"></h2Title>
            <div class="datalistBox">
              <div class="datalist" v-for="child in message.children" :key="message.id">
                <div>
                  {{child.todoName}}
                </div>

                <div>
                  <p>{{child.todoDate}}</p>
                  <p class="btn" v-if="child.type=='30430001'&&child.todoStatus=='1'" @click="confirmTodo(child.id)">完成</p>
                  <p class="btn btn1" v-else-if="child.type=='30430001'&&child.todoStatus=='2'">已完成</p>
                  <p class="btn" v-if="child.type=='30430002'&&child.todoStatus=='1'" @click="gotoUrl(child)">去办理</p>
                  <p class="btn btn1" v-else-if="child.type=='30430002'&&child.todoStatus=='2'">已办理</p>
                </div>
              </div>
            </div>
					</div>
					<div class="nodata" v-if="Messages.length==0&&loaded">
						<img src="@/assets/img/main/noData.png" alt="">
						<p>暂无待办/消息</p>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		queryCalendarData,
		addTodo,
		queryTodoMsg,
		updateTodoStatus
	} from "@/api/msg/msg";
	import h2Title from "@/page/statistics/template/title.vue";
	export default {
		name: "calendar",
		props: {
			showMask: {
				type: Boolean,
				default: () => (
					false
				)
			},
		},
		components: {
			h2Title,
		},
		data() {
			const checkToDoRemindType = (rule, value, callback) => {
        if (value.length==0&&this.firstChange>0) {
          callback(new Error('请选择提醒方式'));
        }else {
					this.firstChange++;
          callback();
        }
      };
			return {
				loading:false,
				lunar: '',
				firstChange:0,
				Agencys: [{
					date: '15',
					agency: '元旦'
				}],
				days: [],
				weekDaysE: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
				weekDays: ['日', '一', '二', '三', '四', '五', '六'],
				monthList: [this.getDatePickerMonths.jan, this.getDatePickerMonths.feb, this.getDatePickerMonths.mar, this.getDatePickerMonths.apr, this.getDatePickerMonths.may, this.getDatePickerMonths.jun, this.getDatePickerMonths.jul, this.getDatePickerMonths.aug, this.getDatePickerMonths.sep, this.getDatePickerMonths.oct, this.getDatePickerMonths.nov, this.getDatePickerMonths.dec],
				currentDay: new Date().getDate(),
				currentMon: new Date().getMonth() + 1,
				currentYear: new Date().getFullYear(),
				form: {
					toDoName: '',
					toDoDate: '',
					toDoStartTime: '',
					toDoEndTime: '',
					toDoRemindLong: '',
					toDoRemindType: []
				},
				radio: false,
        showRemindType:false,//显示提醒方式
				options: [
				  { value: '0', label: '无' },
          { value: '15', label: '提前15分钟' },
          { value: '30', label: '提前30分钟' },
          { value: '60', label: '提前1小时' },
          { value: '120', label: '提前2小时' },
          { value: '1440', label: '提前1天' },
        ],
				ways: [{
						value: '1',
						label: '消息提醒'
					},
					{
						value: '2',
						label: '电子邮件'
					},
					{
						value: '3',
						label: '短信'
					}
				],
				visible: false,
				rules: {
					toDoName: [{
						required: true,
						message: '请填写详细信息',
						trigger: 'blur'
					}],
					toDoDate: [{
						required: true,
						message: '请选择日期',
						trigger: 'blur'
					}],
					toDoStartTime: [{
						required: true,
						message: '请选择开始时间',
						trigger: 'blur'
					}],
					toDoEndTime: [{
						required: true,
						message: '请选择结束时间',
						trigger: 'blur'
					}],
					toDoRemindLong: [{
						required: true,
						message: '请选择提醒时长',
						trigger: 'change'
					}],
					toDoRemindType: [{
						validator: checkToDoRemindType,
						trigger: 'change'
					}],
				},
				Messages: [],
				loaded: false
				// dialogheaderVisible:false,
			}
		},
		watch: {
			visible(val, oldVal) { //普通的watch监听
				this.$emit('update:showMask', val);
				var month = this.currentMon;
        var day = this.currentDay;
        if(month<10){
          month="0"+month;
        }
        if(day<10){
          day="0"+day;
        }
				var currentDate = this.currentYear + '-' + month + '-' + day;
				this.firstChange = 0;
				this.radio = false;
				if(currentDate!=this.form.toDoDate){
					this.form = Object.assign(this.form,{
              toDoName: '',
              toDoDate: currentDate,
              toDoStartTime: '',
              toDoEndTime: '',
              toDoRemindLong: '',
              toDoRemindType: []
          });
          this.$refs["form"].clearValidate();
        }
			},
			radio(val, oldVal){
				if(val){
					this.$set(this.form,'toDoStartTime','00:00');
					this.$set(this.form,'toDoEndTime','23:59');
				}else{
				  if(this.form.toDoStartTime=='00:00'&&this.form.toDoEndTime=='23:59'){
            this.$set(this.form,'toDoStartTime','');
            this.$set(this.form,'toDoEndTime','');
          }
				}
			},
      'form.toDoStartTime'(val, oldVal){
        if(val) {
          if(val!== '00:00'){
              this.radio = false
          }
        }
      },
      'form.toDoEndTime'(val, oldVal){
        if(val) {
          if(val!== '23:59'){
              this.radio = false
          }
        }
      },
      //提醒设置变化时
      'form.toDoRemindLong'(val, oldVal){
        if(val=='0'||val==''){
          this.showRemindType = false;
        }else{
          this.showRemindType = true;
        }
      }
		},
		created() {
			this._queryCalendarData({
				month: ''
			}, true);
		},
		computed: {
			getWeek() {
				return new Date(this.currentYear + '/' + this.currentMon + '/' + this.currentDay).getDay();
			},
      getDatePickerMonths() {
			  const months = this.$t('el.datepicker.months');
			  return months;
      }
		},
		methods: {
			confirmTodo(id){
				this.$confirm('此操作修改待办状态, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.todo(id);
        })
			},
      //去办理
      gotoUrl(todo){
			  if(todo.linkUrl){
			    var params={};
			    if(todo.linkParams&&todo.linkValues){
			      var paramArr = todo.linkParams.split(',');
            var valueArr = todo.linkValues.split(',');
            for(let i=0;i<paramArr.length;i++){
              if(valueArr[i]){
                params[paramArr[i]]= valueArr[i];
              }else{
                params[paramArr[i]]= '';
              }
            }
          }
          this.$router.push({
            path: todo.linkUrl,
            query: params
        });
        }
      },
			todo(id) {
				updateTodoStatus({
					id: id,
					status: '2'
				}).then(res => {
					if (res.data.code == '0') {
            this.$message.success( "修改成功!" );
						let date = this.currentYear + '-' + (this.currentMon >= 10 ? this.currentMon : '0' + this.currentMon) + '-' + (
							this.currentDay >= 10 ? this.currentDay : '0' + this.currentDay);
						this._queryTodoMsg(date);
						this._queryCalendarData({
							month: this.currentYear + '-' + (this.currentMon >= 10 ? this.currentMon : '0' + this.currentMon)
						});
					}
				})
			},
			readMessage(day) {
				this.lunar = day.lunar;
				this.currentDay = day.day;
				let date = this.currentYear + '-' + (this.currentMon >= 10 ? this.currentMon : '0' + this.currentMon) + '-' + (day.day >=
					10 ? day.day : '0' + day.day);
				this._queryTodoMsg(date);
			},
			_queryTodoMsg(date) {
				this.loading = true;
				queryTodoMsg(date).then(res => {
					this.Messages = res.data.data;
					this.loading = false;
					this.loaded = true;
				})
			},
			_queryCalendarData(obj, once) {
				queryCalendarData(obj).then(res => {
					if (once) {
						this._queryTodoMsg(res.data.data.currentDate);
						this.currentDay = parseInt(res.data.data.currentDate.slice(-2))
						res.data.data.monthData.map(data => {
							if (data.day == this.currentDay && data.lunar) {
								this.lunar = data.lunar
							}
						})
					}
					this.currentYear = parseInt(res.data.data.month.slice(0, 4));
					this.currentMon = parseInt(res.data.data.month.slice(-2));

					this.days = res.data.data.monthData;
				})
			},
			onSubmit() {
				this.$refs.form.validate((valid) => {
					if (valid) {
						addTodo(this.form).then(res => {
							if (res.data.code == 0) {
                this.$message.success( res.data.msg );

								this.visible = false;
								this._queryCalendarData({
									month: ''
								}, true);
							}

						});
					} else {
						return false;
					}
				});
				// this.visible = false;
			},
			prveYear() {
				let year = this.currentYear - 1;
				let month = this.currentMon >= 10 ? this.currentMon : '0' + this.currentMon;
				this._queryCalendarData({
					month: year + '-' + month
				});
			},
			nextYear() {
				let year = this.currentYear + 1;
				let month = this.currentMon >= 10 ? this.currentMon : '0' + this.currentMon;
				this._queryCalendarData({
					month: year + '-' + month
				});
			},
			changeMonth(month) {
				let month1 = month >= 10 ? month : '0' + month;
				this._queryCalendarData({
					month: this.currentYear + '-' + month1
				});
			}
		}
	};
</script>

<style scoped>
  .datalists{
    height: calc(100% - 100px);
  }
	#form>>>.el-input--suffix .el-input__inner {
		padding-right: 0;
	}

	.showMask {
		position: relative;
		z-index: 10;
	}

	#form>>>.el-date-editor .el-range-separator {
		font-size: 12px;
		min-width: 12px;
	}

	#form>>>input::placeholder {
		font-size: 12px !important;

		color: #999 !important;
	}

	.nodata {
		text-align: center;
		padding-top: 130px;
	}

	.nodata p {
		font-size: 14px;
		font-weight: 600;
		color: rgba(153, 153, 153, 1);
		line-height: 20px;
		margin-top: 25px;
	}

	#save {
		text-align: center;
		margin-top: 20px;
	}

	#save>>>.el-button {
		background: rgba(255, 134, 121, 1);
	}

	#form>>>.el-checkbox {
		line-height: 26px;
	}

	.textarea>>>textarea {
		height: 94px;
		resize: none;
	}
.remind >>> .el-form-item__label:before{
  display: none;
}
  .calendar .right .datalistBox{
    height: calc(100% - 54px);
    overflow-y: auto;
    padding-bottom: 10px;
  }
	.calendar .right .datalist>div:nth-of-type(2) .btn {
		height: 23px;
		background: rgba(99, 154, 236, 1);
		border-radius: 4px;
		font-size: 14px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(255, 255, 255, 1);
		line-height: 22px;
		text-align: center;
		cursor: pointer;
		width: 50px;
		margin: 5px auto 0;
	}

	.calendar .right .datalist>div:nth-of-type(2) .btn1 {
		background: rgba(213, 214, 216, 1);
		cursor: not-allowed;
	}


	.calendar .right .datalist>div:nth-of-type(2) p {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		line-height: 17px;
	}

	.calendar .right .datalist>div:nth-of-type(1) {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 20px;
    flex:1;
    padding-right: 10px;
	}

	.calendar .right .datalist:nth-last-of-type(1) {
		margin-bottom: 0;
	}

	.calendar .center .day ul.week li {
		margin-bottom: 25px;
	}

	.calendar .right .datalist {
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 62px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 4px 0px rgba(140, 140, 140, 0.26);
		border-radius: 4px;
		margin-right: 10px;
		padding-left: 10px;
		padding-right: 10px;
		margin-bottom: 10px;
	}

	.calendar .right h3>div {
		font-size: 20px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(102, 102, 102, 1);
		line-height: 28px;
		margin-right: 20px;
	}
  @media screen  and (max-width: 1409px) {
    .calendar .right h3>div {
      margin-right: 10px;
    }
  }
	.calendar .right h3>div:nth-last-child(1){
		margin-right: 0;
	}
	.calendar .right h3>div:nth-of-type(2),
	.calendar .right h3>div:nth-of-type(4) {
		font-size: 16px;

	}

	.calendar .right h3>div:nth-of-type(3) {
		font-weight: 600;
	}

	.calendar .right h3 {
		display: flex;
		padding: 24px 24px 10px 10px;
		align-items: baseline;
		/* justify-content: space-between; */
	}

	.calendar .right h3 div font {
		font-size: 40px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: rgba(102, 102, 102, 1);
		line-height: 56px;
	}


	.calendar .right {
		flex-grow: 1;
		padding-left: 10px;
	}

	.calendar .center .footer>div {
		position: absolute;
		right: 40px;
		bottom: 0;
		cursor: pointer;
		width: 40px;
		height: 40px;
	}

	.calendar .center .footer p>span {
		margin-right: 47px;
	}

	.calendar .center .footer .round {
		display: inline-block;
		width: 12px;
		height: 12px;
		background: rgba(236, 88, 88, 1);
		border-radius: 50%;
		margin-right: 10px;
	}

	.calendar .center .footer p>span:nth-of-type(2) .round {
		background: rgba(239, 153, 29, 1);
	}

	.calendar .center .footer p:nth-of-type(2) {
		margin-top: 6px;
	}

	.calendar .center .footer p:nth-of-type(2)>span:nth-of-type(1) .round {
		background: rgba(100, 228, 201, 1);
	}

	.calendar .center .footer p:nth-of-type(2)>span:nth-of-type(2) .round {
		background: rgba(41, 171, 89, 1);
	}

	.calendar .center .footer span {
		font-size: 12px;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		vertical-align: middle;
		height: 17px;
		line-height: 17px;
		display: inline-block;

	}

	.calendar .center .footer {
		position: absolute;
		left: 20px;
		bottom: 37px;
		width: calc(100% - 20px);
		text-align: left;
	}

	.calendar .center .day ul li span {
		display: inline-block;
		text-align: center;
		height: 21px;
		/* background:rgba(236,88,88,1); */
		border-radius: 11px;
		font-size: 12px;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		cursor: pointer;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		border: 1px solid #fff;
		line-height: 20px;
	}

	.calendar .center .day ul li span>span {
		border: 1px solid transparent;
	}

	.calendar .center .day ul li span.active,
	.calendar .center .day ul li span.active>span {
		background: rgba(236, 88, 88, 1);
		color: #fff;
	}

	.calendar .center .day ul li span.active {
		border: 1px solid rgba(236, 88, 88, 1);
		position: absolute;
		z-index: 10;
		transition: .2s;
		width: 21px;
	}

	.calendar .center .day ul li span.finish,
	.calendar .center .day ul li span.finish>span,
	.calendar .center .day ul li span.finish {
		background: #29AB59;
	}

	.calendar .center .day ul li span.finish {
		border: 1px solid #29AB59;
	}

	.calendar .center .day ul li span.active:hover>span {
		background: #fff;
		color: #EC5858;
	}

	.calendar .center .day ul li span.finish:hover>span {
		color: #29AB59;
	}

	.calendar .center .day ul li span.active:hover {
		width: 75px;
    z-index: 99;
	}

	.calendar .center .day ul li span.active:hover>font {
		display: inline-block;
	}

	.calendar .center .day ul li span>span {
		line-height: 20px;
		width: 19px;
		height: 19px;
		min-width: 19px;
		justify-content: center;
	}

	.calendar .center .day ul li span.active font {
		padding: 0 2px;
		white-space: nowrap;
		color: rgba(255, 255, 255, 1);
		display: none;
	}

	/* .calendar .center .day ul li span.active font{
		display: none;
	} */
	.calendar .center .day ul li .festival {
		position: absolute;
		font-size: 10px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(245, 130, 139, 1);
		line-height: 14px;
		white-space: nowrap;
		left: -2px;
		bottom: -16px;
	}

	.calendar .center .day ul li {
		font-size: 12px;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 17px;
		width: 40px;
		text-align: left;
		margin-bottom: 45px;
		position: relative;
	}

	.calendar .center .day ul {
		display: flex;
		margin-top: 30px;
		flex-wrap: wrap;
	}

	.calendar .center h2 {
		font-size: 28px;
		font-weight: 600;
		color: rgba(102, 102, 102, 1);
		line-height: 40px;
		text-align: left;
	}

	.calendar .center {
		width: 310px;
		padding: 30px 10px 30px 20px;
		height: 100%;
		box-sizing: border-box;
		position: relative;

	}



	.calendar {
		height: 595px;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 4px 0px rgba(183,183,183,0.15), 0px 2px 4px 0px rgba(183,183,183,0.15);
		border-radius: 9px;
		display: flex;
		overflow: hidden;
	}

	@media screen and (min-width: 1920px) {
		.calendar {
			height: 660px;
		}

		.calendar .center {
			width: 520px;
		}

		.calendar .center .day ul li {
			width: 70px;
		}

		.nodata {
			padding-top: 180px;
		}
	}

	.calendar .left {
		width: 72px;
		background: #4278D2;
		height: 100%;
		margin-top: 0;
	}

	.calendar .left .year {
		margin-top: 25px;
		text-align: center;
	}

	.calendar .left .year i,
	.calendar .left .year span {
		color: #fff;
	}

	.calendar .left .year i {
		cursor: pointer;
	}

	.calendar .left .year p>span.currentYear {
		display: inline-block;
		text-align: center;
		line-height: 29px;
		width: 58px;
		height: 29px;
		background: rgba(255, 255, 255, 1);
		border-radius: 15px;
		border: 1px solid rgba(255, 255, 255, 1);
		font-size: 14px;
		font-weight: 600;
		color: #4278D2;
		margin: 12px 0;
	}

	.month {
		margin-top: 25px;
	}

	.month li {
		text-align: center;
	}

	.month li span {
		display: inline-block;
		height: 34px;
		line-height: 34px;
		padding: 0 7px;
		border-radius: 11px;
		font-size: 14px;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		cursor: pointer;
	}

	.month li span.active {
		background: #fff;
		color: #4278D2;
	}

  @media screen and (max-width: 1400px) {
	   .calendar .right h3 div font {
	   	font-size: 30px;
			}
			.calendar .right h3>div{
				font-size: 16px;
			}
	}

</style>
